<template>
    <div ref="el2">
        <div class="container" id="splashscreen">
            <h2>SEARCH OUR EVENTS</h2>
            <events-view :orgid="orgid" :org-name="orgname" :colour="colour"></events-view>
        </div>
    </div>
</template>

<script setup>
import { useElementSize } from '@vueuse/core'
import EventsView from './events-view.vue'
import { defineProps, ref, watch } from 'vue'

const url = new URL(location.href).origin

const el2 = ref(null)

const { height, width } = useElementSize(el2)

const props = defineProps({
    orgid: String,
    orgname: String,
    colour: String
})


// TODO needs to be the current url for *
watch(height, async (newHeight) => {
    console.log('height changed')
    parent.postMessage(
            {
                height: newHeight,
            },
            '*'
        );
})

</script>